module.exports = __webpack_public_path__ + "img/tintuc17.40df209d.png";